export default "__VITE_ASSET__BZ$s3_cf__"